import { Box, Image } from "@chakra-ui/react";
import type { Companion } from "src/models/companion";

/**
 * Round face crop of the companion's scene picture, with an optional ring
 * in their colour (and a gap, like a story ring).
 */
export function CompanionAvatar({
  companion,
  size,
  ring = false,
}: {
  companion: Companion;
  size: string;
  ring?: boolean;
}) {
  const inner = companion.avatarURL ? (
    <Image
      src={companion.avatarURL}
      alt={companion.name}
      boxSize="100%"
      borderRadius="full"
      objectFit="cover"
      objectPosition="50% 28%"
      draggable={false}
      loading="lazy"
    />
  ) : (
    <Box
      boxSize="100%"
      borderRadius="full"
      bg={companion.color}
      color="white"
      display="flex"
      alignItems="center"
      justifyContent="center"
      fontWeight="bold"
      fontSize={`calc(${size} * 0.4)`}
    >
      {companion.name.charAt(0)}
    </Box>
  );

  if (!ring) {
    return (
      <Box boxSize={size} flexShrink={0}>
        {inner}
      </Box>
    );
  }
  return (
    <Box
      boxSize={size}
      flexShrink={0}
      borderRadius="full"
      p="2px"
      bg={`linear-gradient(135deg, ${companion.color}, #ff6257)`}
    >
      <Box boxSize="100%" borderRadius="full" p="2px" bg="app">
        {inner}
      </Box>
    </Box>
  );
}
